import api from './api';

const shippingMethodsService = {
  // Récupérer tous les modes de livraison
  getAll: async () => {
    const response = await api.get('/api/admin/shipping-methods');
    return response.data;
  },

  // Récupérer un mode de livraison par ID
  getById: async (id) => {
    const response = await api.get(`/api/admin/shipping-methods/${id}`);
    return response.data;
  },

  // Créer un nouveau mode de livraison
  create: async (data) => {
    const response = await api.post('/api/admin/shipping-methods', data);
    return response.data;
  },

  // Mettre à jour un mode de livraison
  update: async (id, data) => {
    const response = await api.put(`/api/admin/shipping-methods/${id}`, data);
    return response.data;
  },

  // Supprimer un mode de livraison
  delete: async (id) => {
    const response = await api.delete(`/api/admin/shipping-methods/${id}`);
    return response.data;
  },

  // Activer/Désactiver un mode de livraison
  toggleAvailability: async (id) => {
    const response = await api.post(`/api/admin/shipping-methods/${id}/toggle`);
    return response.data;
  },

  // Récupérer les pays autorisés pour un mode
  getCountries: async (id) => {
    const response = await api.get(`/api/admin/shipping-methods/${id}/countries`);
    return response.data;
  },

  // Mettre à jour les pays autorisés
  updateCountries: async (id, countryCodes) => {
    const response = await api.put(`/api/admin/shipping-methods/${id}/countries`, { countryCodes });
    return response.data;
  },

  // Obtenir la liste de tous les pays disponibles
  getAvailableCountries: async () => {
    const response = await api.get('/api/admin/shipping-methods/available-countries');
    return response.data;
  },
};

export default shippingMethodsService;

